module.exports = __webpack_public_path__ + "static/Im-He-1.90e560f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/Im-He-1.jpg
// module id = 524
// module chunks = 27362984104999